import { Guard, isNumber, isType } from "../utils";
import { Goals } from "./goals";
import { FunctionFactory } from "survey-core";
import { loc } from "../i18n/survey";

function validateGoalWeight(params: any[]): boolean {
  if (params === undefined || params === null) return false;
  const weightRaw = params[0] as number | undefined;
  const goalWeight = params[1] as number | undefined;
  if (goalWeight != null && weightRaw != null && goalWeight < weightRaw) {
    return true;
  }
  return false;
}

const validateGoalWeightExpression = {
  name: 'validateGoalWeight',
  expression: "validateGoalWeight({weight}, {goalWeight})",
};

FunctionFactory.Instance.register('validateGoalWeight', validateGoalWeight);

const goalWeightQuestion = {
  name: "goalWeightPanel",
  visibleIf: `{goals} = "${Goals.LoseFat}"`,
  title: loc("quiz.goalWeight.title"),
  description: loc("quiz.goalWeight.description"),
  descriptionLocation: "underTitle",
  type: "multipletext",
  inputType: "number",
  items: [],
};

const goalWeightRaw = {
  visibleIf: `{goals} = "${Goals.LoseFat}"`,
  type: "text",
  inputType: "number",
  titleLocation: 'left',
  name: "goalWeight",
  isRequired: true,
  title: "{weightUnit}",
  placeholder: loc("quiz.goalWeight.placeholder"),
  validators: [{
    type: "numeric",
    minValue: 25,
    text: loc("quiz.weight.invalid"),
  }, {
    type: "expression",
    expression: "validateGoalWeight({weight}, {goalWeight})",
    text: loc("quiz.goalWeight.notLessThanCurrent"),
  }],
};

export {
  goalWeightRaw,
  goalWeightQuestion,
  validateGoalWeightExpression,
}